import React from 'react';

import Quotes from './Quotes';
import {
    Wrapper,
    QuoteColumn,
    QuoteBackground,
    TextWrapper,
    Text,
    Author
} from './styled-components';

/**
 * @type {enum}
 * 
 * describes the possible styles for this component
 */
export const quoteType = {
    WHITE: 1,
    GREY: 2,
    RED: 3,
}

/**
 * @param {string} text - the main quote text
 * @param {string} author - the quotes author
 * @param {enum: WHITE, GREY, RED} displayType - defines the appereance of the component 
 */
const Quote = ({text, author, typeName}) => {
    const displayType = quoteType[typeName.toUpperCase()];

    return (
        <Wrapper displayType={displayType}>
            {displayType === quoteType.WHITE && <QuoteColumn><Quotes/></QuoteColumn>}
            <TextWrapper displayType={displayType}>
                <Text displayType={displayType}>{text}</Text>
                <Author displayType={displayType}>{author}</Author>
            </TextWrapper>
            {displayType === quoteType.RED && <QuoteBackground><Quotes/></QuoteBackground>}
        </Wrapper>
    );
}

Quote.defaultProps = {
    text: 'There is a way out of every box, a solution to every puzzle; it\'s just a matter of finding it',
    author: '- DEAN LUC PICARD',
    typeName: 0,
};

export default Quote;